import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {ObservableBackendService} from "./observableBackend.service";
import {Vehicle} from "../domain/vehicle";
import {Page} from "../domain/page";
import {URLSearchParams} from "@angular/http";
import {Procedure} from "../domain/procedure";

@Injectable()
export class PatentPaymentService {

    constructor(private backendService: ObservableBackendService) {
    }

    public findPatentPayment(filter: Vehicle, page: number, itemsPerPage: number): Observable<Page> {
        let params = new URLSearchParams();
        if (filter.patent) {
            params.set('patent', filter.patent);
        }
        if (filter.contract.bank && filter.contract.bank.id) {
            params.set('contract.bank.id', filter.contract.bank.id);
        }
        if (filter.contract.contractNumber) {
            params.set('contract.contractNumber', filter.contract.contractNumber);
        }
        if (filter.contract.cuit) {
            params.set('contract.cuit', filter.contract.cuit);
        }
        params.set('length', String(itemsPerPage));
        params.set('pageNumber', String(page));
        return this.backendService.get("patent_payment", params);
    }

    public getVehicle(vehicleId: string): Observable<Vehicle> {
        return this.backendService.get("vehicle/" + vehicleId + "/patentPayment ", null);
    }

    public save(vehicle: Vehicle): Observable<Vehicle> {
        return this.backendService.post("vehicle/patentPayment", vehicle, null);
    }

    public static getURLPatentPaymentBulkload(documentId: string): string {
        return "/patentPaymentsBulkloadDocument/" + documentId;
    }

    public delete(patentPaymentId: string): Observable<Procedure> {
        return this.backendService.delete("patentPayment/" + patentPaymentId, null, null);
    }

    private static setParams(filter: Vehicle, page: number, itemsPerPage: number, withDocuments?: boolean): URLSearchParams {
        let params = new URLSearchParams();
        if (filter.patent) {
            params.set('patent', filter.patent);
        }
        if (filter.contract.bank && filter.contract.bank.id) {
            params.set('contract.bank.id', filter.contract.bank.id);
        }
        if (filter.contract.contractNumber) {
            params.set('contract.contractNumber', filter.contract.contractNumber);
        }
        if (filter.contract.cuit) {
            params.set('contract.cuit', filter.contract.cuit);
        }
        if (filter.procedures.length > 0) {
            params.set('procedures[0].type.id', filter.procedures[0].type.id);
        }
        params.set('length', String(itemsPerPage));
        params.set('pageNumber', String(page));

        /*Opcional: descarga de documentos*/
        params.set('withDocuments', String(withDocuments));
        return params;
    }

    public static getURLFilterPatentPayments(filter: Vehicle, page: number, itemsPerPage: number, withDocuments: boolean): string {
        return "/patentPaymentsReport?" + PatentPaymentService.setParams(filter, page, itemsPerPage, withDocuments).toString();
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/service/patentPayment.service.ts
 **/